import { useEffect, useState } from "react";
import Draggable from "react-draggable";
import { Box } from "@chakra-ui/layout";
import { COMMON_WEB_PATH, WEB_LAYOUT } from "../../../constant";
import useDeviceType from "../../../hook/useDeviceType";
import { IoIosArrowForward } from "react-icons/io";
import { useTranslation } from "react-i18next";
import useCheckLogin from "../../../hook/useCheckLogin";
import { useNavigate, useParams } from "react-router-dom";
import UseGetGameBoxBackPathV2 from "../../../hook/useGetGameBoxBackPath_v2";
import { useSelector } from "react-redux";
import useIsLandScapeMachine from "../../../hook/useIsLandScapeMachine";
import useEventMessage from "../../../hook/useEventMessage";
import useGames from "../useGames";

const PCToolTab = ({ hiddenHeader, setHiddenHeader }) => {
  const { t } = useTranslation();
  const i18n = (key) => t(`common.${key}`);
  const [dragStartTime, setDragStartTime] = useState(0);

  const handleStart = () => {
    setDragStartTime(Date.now());
  };

  const { handleExitGame } = useGames();

  const handleStop = () => {
    if (Date.now() - dragStartTime < 200) {
      // if (isMachineUser) {
      //   navigate(`/${getPrevPath}/category/${SubPlatformEnum || to}/AllGames`);
      // } else {
      //   setHiddenHeader(false);
      // }
      handleExitGame();
    }
  };

  const isMachineLandscape = useIsLandScapeMachine();

  return (
    hiddenHeader && (
      <Draggable onStart={handleStart} onStop={handleStop}>
        <Box
          position={"absolute"}
          bgImage={`url('${COMMON_WEB_PATH}/911TW/titleBG5.webp')`}
          bgPosition="center"
          bgRepeat="no-repeat"
          bgSize="100%100%"
          left={"0px"}
          top={isMachineLandscape ? "unset" : "0px"}
          bottom={isMachineLandscape ? "0px" : "unset"}
          minW={"48px"}
          h={"52px"}
          rounded={"5px"}
          gap={"10px"}
          alignItems={"center"}
          justifyContent={"center"}
          cursor="pointer"
          className={`!flex`}
          zIndex={999999}
          sx={{
            "& > *": {
              color: "text-yellow-500",
            },
          }}
        >
          {" "}
          {/* <IoIosArrowForward className="text-2xl" /> */}
          {i18n("leave")}
        </Box>
      </Draggable>
    )
  );
};

export default PCToolTab;
